<script>
import textComponent from '@/components/backoffice/type/text'
import objectComponent from '@/components/backoffice/type/url/local'
import booleanComponent from '@/components/backoffice/type/boolean'
import numberComponent from '@/components/backoffice/type/number'
import imageComponent from '@/components/backoffice/type/image'
import urlComponent from '@/components/backoffice/type/url/href'
import emailComponent from '@/components/backoffice/type/email'
import categoryComponent from '@/components/backoffice/type/category'
import roleComponent from '@/components/backoffice/type/role'
import phoneNumberComponent from '@/components/backoffice/type/phoneNumber'
import dateComponent from '@/components/backoffice/type/date'
import dateWithDayComponent from '@/components/backoffice/type/dateWithDay'
import dateTimeComponent from '@/components/backoffice/type/datetime'
import fullNameComponent from '@/components/backoffice/type/fullName'
import currencyComponent from '@/components/backoffice/type/currency'
import formatter from '@/components/global/mixins/formatterMethods'
import companyCfComponent from '@/components/backoffice/type/companycf'
import hiddenComponent from '@/components/backoffice/type/hidden.vue'
import statusComponent from '@/components/backoffice/type/status.vue'

export default {
  components: {
    textComponent,
    objectComponent,
    booleanComponent,
    numberComponent,
    imageComponent,
    urlComponent,
    emailComponent,
    categoryComponent,
    roleComponent,
    phoneNumberComponent,
    dateComponent,
    dateWithDayComponent,
    dateTimeComponent,
    fullNameComponent,
    currencyComponent,
    companyCfComponent,
    hiddenComponent,
    statusComponent
  },

  mixins: [formatter],

  props: {
    item: {
      type: Object,
      required: true
    },
    width: String,
    alone: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      textTypes: ['text', 'longText']
    }
  },

  methods: {
    getTag () {
      let tag = this.textTypes.includes(this.item.type)
        ? 'text'
        : this.item.type

      return tag + '-component'
    },

    getProps () {
      let ret = {
        width: this.width
      }

      for (let prop in this.item) {
        if (this.item.hasOwnProperty(prop)) {
          ret[prop] = this.item[prop]
        }
      }

      if (this.item.type === 'object') {
        ret.routeName = this.item.routeName || (this.item.entityName + '_show')
        ret.value = this.item.value ? this.formatDisplay(this.item.value, this.item.entityName) : ''
        ret.id = this.item.value ? this.item.value.id : null
      }

      ret.alone = this.alone

      return ret
    }
  },

  render (h) {
    return h(
      this.getTag(),
      {
        props: this.getProps(),
        class: 'row text-left col',
        width: this.width
      }
    )
  }
}
</script>
